function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 1rem;\n\n  &:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import propTypes from "prop-types";
import styled, { css, withTheme } from "styled-components";
import { Flipper, Flipped } from "react-flip-toolkit";
import { flattenDeep } from "lodash";
import Link from "../link";
import { MediumText } from "../text";
var Tabs = styled.div(_templateObject());
var TabLinksWrapper = styled.div(function(param) {
    var theme = param.theme;
    return css(theme.components.tabs.linksWrapper);
});
var TabLink = styled.div(_templateObject1());
var ActiveIndicator = styled.div.attrs({
    className: "product-details-tab-indicator"
})(function(param) {
    var theme = param.theme;
    return css(theme.components.tabs.indicator);
});
var TabContentWrapper = styled.div(_templateObject2());
export var Tab = styled.div(_templateObject3());
var TabsContainer = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(TabsContainer, PureComponent);
    var _super = _createSuper(TabsContainer);
    function TabsContainer() {
        _classCallCheck(this, TabsContainer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            activeTabIndex: _this.props.defaultTabIndex || 0
        };
        _this.createChangeHandler = function(index) {
            return function(e) {
                e.preventDefault();
                _this.setState({
                    activeTabIndex: index
                });
            };
        };
        return _this;
    }
    var _proto = TabsContainer.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, hideTabIfEmpty = _props.hideTabIfEmpty, theme = _props.theme;
        var _props1 = this.props, labels = _props1.labels, children = _props1.children;
        if (hideTabIfEmpty) {
            var _this1 = this;
            labels = [];
            children = [];
            this.props.labels.filter(function(v, i) {
                var tab = _this1.props.children[i];
                var tabChildren = flattenDeep(tab.props.children).filter(Boolean);
                if (!React.Children.count(tabChildren)) return;
                labels.push(v);
                children.push(tab);
            });
        }
        var activeTabIndex = this.state.activeTabIndex;
        var activeTab = children[activeTabIndex] || children;
        return /*#__PURE__*/ React.createElement(Tabs, null, labels.length > 1 && /*#__PURE__*/ React.createElement(Flipper, {
            flipKey: activeTabIndex
        }, /*#__PURE__*/ React.createElement(TabLinksWrapper, null, labels.map(function(label, i) {
            return /*#__PURE__*/ React.createElement(TabLink, {
                key: i,
                "data-tab": label,
                className: "".concat(i === activeTabIndex ? "active" : "", " product-details-tab-link")
            }, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(Link, {
                inactive: i !== activeTabIndex,
                onClick: _this.createChangeHandler(i)
            }, label)), i === activeTabIndex && /*#__PURE__*/ React.createElement(Flipped, {
                flipId: "activeIndicator",
                translate: true,
                opacity: true,
                scale: !theme.components.tabs.disableIndicatorScalingAnimation
            }, /*#__PURE__*/ React.createElement(ActiveIndicator, null)));
        }))), /*#__PURE__*/ React.createElement(TabContentWrapper, null, activeTab));
    };
    return TabsContainer;
}(PureComponent);
TabsContainer.propTypes = {
    labels: propTypes.arrayOf(propTypes.string),
    hideTabIfEmpty: propTypes.bool
};
export default Object.assign(withTheme(TabsContainer), {
    Tabs: Tabs,
    TabLink: TabLink
});
